import React, { FC, MouseEvent, useState } from 'react';
import { Form, Modal } from 'antd';

// Shared UI Library Components
import { CustomButton, CustomIcon, CustomTextArea, EIconName } from '@ppmcore/seven-ppm-core-shared-components-react';

// Styles
import './refund-modal.scss';

interface IRefundModalProps {
  open: boolean;
  amount: string;
  loading?: boolean;
  onSubmit?: (reason: string) => void;
  onCancel?: () => void;
}

export const RefundModal: FC<IRefundModalProps> = (
  {
    open = false,
    amount,
    loading = false,
    onSubmit = () => {
    },
    onCancel = () => {
    }
  }: IRefundModalProps
) => {
  const [form] = Form.useForm();

  const [reasonValue, setReasonValue] = useState<string>('');
  const [showConfirmation, setShowConfirmation] = useState<boolean>(false);

  const handleCancel = (e?: MouseEvent<HTMLButtonElement>): void => {
    form.resetFields();
    setReasonValue('');
    setShowConfirmation(false);
    onCancel();
  };

  const handleRefundClick = async (): Promise<void> => {
    if (!reasonValue.trim().length) return;
    setShowConfirmation(true);
  }

  const handleConfirmCancel = (): void => {
    setShowConfirmation(false);
  }

  const handleConfirmSubmit = (): void => {
    onSubmit(reasonValue);
  }

  // Confirmation step
  if (showConfirmation) {
    return (
      <Modal
        rootClassName="refund-modal"
        width={'395px'}
        open={open}
        centered={true}
        closeIcon={false}
        title={`Are you sure you want to refund ${amount}?`}
        footer={[
          <CustomButton key="cancel" text={'Cancel'} type={'text'} onClick={handleConfirmCancel} disabled={loading} />,
          <CustomButton key="confirm" text={'Refund'} loading={loading} onClick={handleConfirmSubmit} />,
        ]}
        onCancel={handleConfirmCancel}
      />
    );
  }

  return (
    <Modal
      rootClassName="refund-modal"
      width={'604px'}
      open={open}
      centered={true}
      closeIcon={<CustomIcon name={EIconName.Close} />}
      title={'Refund payment'}
      footer={[
        <CustomButton key="cancel" text={'Cancel'} type={'text'} onClick={handleCancel} />,
        <CustomButton key="submit" text={'Refund'} disabled={!reasonValue.trim().length} onClick={handleRefundClick} />,
      ]}
      onCancel={handleCancel}
    >
      <Form form={form} className="refund-modal--body">
        <div className="body-item body-item--amount">
          <span className="amount-label">Amount</span>
          <span className="amount-value">{amount}</span>
        </div>
        <div className="body-item">
          <Form.Item
            name="reason"
            rules={[{ required: true, message: 'Please provide a reason for the refund' }]}
          >

            <CustomTextArea
              placeholder={'Please add more details about this refund'}
              onChange={setReasonValue}
              showCount={true}
              maxLength={500}
            />
          </Form.Item>
        </div>
      </Form>
    </Modal>
  )
};
